import { Pagination, PaginationProps } from 'oskcomponents';
import React from 'react';

import { SHORT_VISIBLE_PAGE_SIZE } from '~/pagination';

export type ExternalOrderDashboardPaginatorProps = {
    /** Total count of visible catalog items */
    totalOrders?: number;
    /** Current page for pagination from redux */
    currentPage?: number;
    /** How many results to display at once */
    pageSize?: number;
    /** Event that fires when the user initiates a page change */
    changePage?: (pageNumber: number) => void;
} & Omit<PaginationProps, 'offset'>;

const ExternalOrderDashboardPaginator = ({
    totalOrders,
    currentPage,
    pageSize = SHORT_VISIBLE_PAGE_SIZE,
    changePage,
    ...props
}: ExternalOrderDashboardPaginatorProps) => {
    if (!totalOrders || totalOrders < pageSize) return <></>;

    return (
        <Pagination
            inverted
            style={{
                borderRadius: '0px',
                margin: '0px -14px -14px -14px',
                padding: '14px',
            }}
            onChange={changePage}
            count={totalOrders ?? 0}
            pageSize={pageSize}
            offset={(currentPage ?? 0) * pageSize}
            {...props}
        />
    );
};

export default ExternalOrderDashboardPaginator;
